import { useQuery } from '@tanstack/react-query';
import type { ScopedPortalItem } from './arcGisPortal';
import { useEnvironmentVariables } from 'utils/useEnvironmentVariables';
import { ARCGIS_DISASTER_TECH_ORG_ID } from './arcGisPortal';

const dhsLayerQueryKey = {
  base: ['dhsLayerItems'] as const,
  list: () => [...dhsLayerQueryKey.base] as const,
};

export const useDhsLayers = () => {
  const { data: envData } = useEnvironmentVariables();

  return useQuery({
    queryKey: dhsLayerQueryKey.list(),
    queryFn: async () => {
      const response = await fetch(
        'https://www.arcgis.com/sharing/rest/search',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          body: new URLSearchParams({
            f: 'json',
            q: `orgid:${ARCGIS_DISASTER_TECH_ORG_ID} AND type:"Feature Service" AND tags:"dhs"`,
            num: '100',
            token: envData?.ARCGIS_API_KEY ?? '',
          }),
        }
      );

      if (!response.ok) {
        throw new Error(`DHS Search failed: ${response.statusText}`);
      }

      const data = await response.json();

      if (data.error) {
        throw new Error(data.error?.message || 'Error fetching DHS layers');
      }

      return createApiKeyScopedPortalItems(data.results);
    },
    enabled: !!envData?.ARCGIS_API_KEY,
  });
};

function createApiKeyScopedPortalItems(
  items: __esri.PortalItem[]
): ScopedPortalItem[] {
  const scopedItems = Array.from(items);
  for (const item of scopedItems) {
    (item as ScopedPortalItem).authType = 'apiKey';
    (item as ScopedPortalItem).userScoped = false;
  }

  return scopedItems;
}
